module.exports = __webpack_public_path__ + "images/category_lp/bike/new/assessment_achievements/6_ecb5ba88a17e550b0921095db3d1ef03.png";